// src/components/Featured/WishlistModal.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { usePrice } from "../../../../hooks/usePrice";
import axios from "axios";
import { removeFromWishlist } from "../../../../redux/shop/wishlistSlice";
import { Notify } from "notiflix/build/notiflix-notify-aio";

import { Loader } from "../../../Loader/Loader";
import { ReactComponent as CrossIcon } from "../../../../icons/header/X.svg";
import { ReactComponent as ArrowRightIcon } from "../../../../icons/ArrowRight.svg";

import {
  EmptyMessageStyled,
  ModalLinkStyled,
  ModalListStyled,
  ModalLowerStyled,
  ModalStyled,
  ModalTitleStyled,
  WishlistModalPriceStyled,
} from "./Modal.styled";

const apiUserUrl = `${process.env.REACT_APP_API_BASE_URL}/user`;

export const WishlistModal = ({ onClick }) => {
  const dispatch = useDispatch();
  const { countSalePrice } = usePrice();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // Получение списка товаров в избранном
  useEffect(() => {
    const fetchWishlist = async () => {
      const token = sessionStorage.getItem("accessToken");
      if (!token) {
        // Информационное уведомление вместо ошибки
        Notify.info("Пожалуйста, авторизуйтесь");
        return;
      }

      setLoading(true);
      try {
        const { data } = await axios.get(`${apiUserUrl}/favorite-products`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (data.productResponse) {
          setItems(data.productResponse);
        }
      } catch (err) {
        console.error("Ошибка загрузки избранного:", err);
        Notify.failure("Не удалось загрузить избранное");
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, []);

  // Удаление товара из избранного
  const removeFromWishlistHandler = async (id) => {
    const token = sessionStorage.getItem("accessToken");
    if (!token) {
      Notify.info("Пожалуйста, авторизуйтесь");
      return;
    }

    setLoading(true);
    try {
      await axios.delete(`${apiUserUrl}/remove-favorite/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      dispatch(removeFromWishlist(id));
      setItems((prev) => prev.filter((item) => item.id !== id));
      Notify.success("Товар удалён из избранного");
    } catch (err) {
      console.error("Ошибка удаления из избранного:", err);
      Notify.failure("Не удалось удалить из избранного");
    } finally {
      setLoading(false);
    }
  };

  return (
      <ModalStyled name="wishlist" $wishlist>
        <ModalTitleStyled>
          Избранное{" "}
          {items.length > 0 && (
              <span>({items.length.toString().padStart(2, "0")})</span>
          )}
        </ModalTitleStyled>

        {loading && <Loader />}

        {!loading && items.length > 0 && (
            <ModalListStyled>
              {items.map(({ id, name, categoryName, imageUrls, price }) => (
                  <li key={id}>
                    <img
                        src={
                          imageUrls
                              ? `${process.env.REACT_APP_API_BASE_URL}/public/images/${encodeURIComponent(
                                  imageUrls[0]
                              )}`
                              : "/placeholder.png"
                        }
                        alt={name}
                        width={80}
                        height={80}
                        loading="lazy"
                    />
                    <div>
                      <Link
                          to={`/shop/${categoryName}/${name
                              .toLowerCase()
                              .replaceAll(" ", "-")}?id=${id}`}
                          onClick={onClick}
                      >
                        {name}
                      </Link>
                      <WishlistModalPriceStyled>
                        {countSalePrice(price)}
                      </WishlistModalPriceStyled>
                    </div>
                    <button
                        type="button"
                        onClick={() => removeFromWishlistHandler(id)}
                        disabled={loading}
                        style={{ background: "none", border: "none", cursor: "pointer" }}
                    >
                      <CrossIcon />
                    </button>
                  </li>
              ))}
            </ModalListStyled>
        )}

        {!loading && items.length === 0 && (
            <EmptyMessageStyled>Ваш список «Избранное» пуст!</EmptyMessageStyled>
        )}

        <ModalLowerStyled>
          <ModalLinkStyled to="/wishlist" onClick={onClick}>
            Посмотреть список «Избранное» <ArrowRightIcon />
          </ModalLinkStyled>
        </ModalLowerStyled>
      </ModalStyled>
  );
};
